import "./DrainProblems.module.css";
import Header from "@/reusable_sections/Header";
import DrainProblems from "./sections/DrainProblems";
import DrainSymptoms from "./sections/DrainSymptoms";
import ServiceContact from "./sections/ServiceContact";
import Footer from "@/reusable_sections/Footer";
export default function DrainProblemsPage() {
  return <div>
      <Header />
      <DrainProblems />
      <DrainSymptoms />
      <ServiceContact />
      <Footer />
    </div>;
}